import {Component, Input} from '@angular/core';

@Component({
    selector: 'ui-loading',
    template: `
	    <div *ngIf="loading && !spinner" class="ui-loading progress {{class}}">
		    <div class="progress-bar progress-bar-padded  progress-bar-striped progress-bar-animated"
			 role="progressbar" style="width:100%">
			    <span>{{loadingText}}</span>
		    </div>
	    </div>
	    <div *ngIf="loading && spinner" class="spinner-border text-primary" role="status">
		    <span class="sr-only">{{loadingText}}</span>
	    </div>
    `,
    host: {class: 'ui-loading'}
})
export class UILoadingComponent {

    @Input() loading: boolean = true;
    @Input() spinner: boolean = false;
    @Input() loadingText: any = "";
    @Input() class: any = "";

}
